(function () {
  var CART_SECTION = '[data-section-type="cart-template"]';

  // Fetch complementary products for the cart's first line item, inject up to 3
  // cards (excluding products already in the cart) into the placeholder.
  function load() {
    var host = document.querySelector('[data-cart-complementary]');
    if (!host) return;
    var anchorId = host.getAttribute('data-anchor-id');
    if (!anchorId) return;
    var inCart = (host.getAttribute('data-cart-ids') || '').split(',').filter(Boolean);

    var url = '/recommendations/products?section_id=cart-complementary-products'
            + '&intent=complementary&limit=10&product_id=' + encodeURIComponent(anchorId);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.ccp');
        if (!section) { return; }            // empty state: render nothing
        var row = section.querySelector('.ccp__row');
        var kept = 0;
        Array.prototype.slice.call(row.querySelectorAll('.ccp-card')).forEach(function (card) {
          var pid = card.getAttribute('data-product-id');
          if (inCart.indexOf(pid) !== -1 || kept >= 3) { card.remove(); return; }
          kept += 1;
        });
        if (kept === 0) { return; }          // all complements already in cart
        host.innerHTML = '';
        host.appendChild(section);
        host.dispatchEvent(new CustomEvent('ccp:rendered', { bubbles: true }));
      })
      .catch(function () { /* fail silent: block simply does not appear */ });
  }

  // Re-render the cart section in place (inner HTML only, so theme.Cart's
  // delegated listeners on the container survive), then update the free-shipping
  // bar via its public API and reload the complementary block.
  function refreshCart() {
    return fetch('/?section_id=cart-template', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(CART_SECTION);
        var current = document.querySelector(CART_SECTION);
        if (fresh && current) { current.innerHTML = fresh.innerHTML; }
      })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.theme && theme.freeShipping && typeof theme.freeShipping.updateAll === 'function') {
          theme.freeShipping.updateAll(cart.total_price);
        }
        load();
      });
  }

  // Delegated so it survives cart re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ccp-card__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-variant-id'), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        return refreshCart();
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  });

  load();
})();
